import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxInputFn = /* @__PURE__ */ createRecipe('checkbox-input', {}, [])

const checkboxInputVariantMap = {}

const checkboxInputVariantKeys = Object.keys(checkboxInputVariantMap)

export const checkboxInput = /* @__PURE__ */ Object.assign(memo(checkboxInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxInput',
  __getCompoundVariantCss__: checkboxInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxInputVariantKeys,
  variantMap: checkboxInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxInputVariantKeys)
  },
  getVariantProps: checkboxInputFn.getVariantProps,
})